import { Section } from '@web_opxp/components';
import { AuthSelectors, ObFlowService, OnboardingFlowProgress, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { VideoBaseUrl } from '../base/env';
import VideoPlayerSection from '../components/video/VideoPlayerSection';
import * as FirebaseActions from './firebaseActions';

export interface IIntroVideoSectionProps {
  onIntroStartedHandler: () => void;
  onIntroCloseHandler: () => void;
  onIntroCompletedHandler: () => void;
  session: string | undefined;
}

export const IntroVideoSection: React.FC<IIntroVideoSectionProps> = ({
  onIntroStartedHandler,
  onIntroCloseHandler,
  onIntroCompletedHandler,
  session,
}) => {
  const { language } = useTranslation();
  const finalRedirect = () => ObFlowService.redirectToNextObStep('welcome', language, session);

  const videoName = 'bt_video01';
  const videoPath = `${VideoBaseUrl}/${videoName}`;
  const onCloseHandler = () => {
    onIntroCloseHandler();
    finalRedirect();
  };

  const onVideoCompletedHandler = () => {
    onIntroCompletedHandler();
    finalRedirect();
  };

  return (
    <>
      <VideoPlayerSection
        videoPath={videoPath}
        videoName={videoName}
        onCloseHandler={onCloseHandler}
        onVideoCompletedHandler={onVideoCompletedHandler}
        onVideoStartedHandler={onIntroStartedHandler}
      />
      <Section className="intro-video-progress">
        <OnboardingFlowProgress currentStep="welcome" />
      </Section>
    </>
  );
};

export const mapDispatchToProps = {
  onIntroStartedHandler: FirebaseActions.firebaseOnIntroStartedAction,
  onIntroCloseHandler: FirebaseActions.firebaseOnIntroCloseAction,
  onIntroCompletedHandler: FirebaseActions.firebaseOnIntroCompletedAction,
};

export const mapStateToProps = (state: any) => {
  const session = AuthSelectors.getToken(state);
  return { session };
};

export default connect(mapStateToProps, mapDispatchToProps)(IntroVideoSection);
